import { render, staticRenderFns } from "./AddMedicineCourseModal.vue?vue&type=template&id=91fca42a&"
import script from "./AddMedicineCourseModal.vue?vue&type=script&lang=js&"
export * from "./AddMedicineCourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports